module.exports = __webpack_public_path__ + "static/img/kaishu_benefit2.41f0d12d.jpg";